import React, {useState} from "react";
import i18n from "../../../i18n";

export default function VideoBlock({ item }) {

    const [mediaFile, setMediaFile] = useState(null);
    React.useEffect(() => {
        if (item.data['media'] && item.data['media'][i18n.language]) {
            setMediaFile(item.data['media'][i18n.language].preview_url);
        }

    }, [item])

    return (
        <div className="">
            {item &&
                <>
                    { mediaFile &&
                        <video controls className="w-full" autoPlay={false}>
                            <source src={ mediaFile } type="video/mp4" />
                        </video>
                    }
                </>
            }
        </div>
    )
}